import { Select } from '../Select/index.js'

import { FormControlLayout } from './FormControlLayout.js'
import { FormControlSelectProps } from './types.js'
import {
  extractLayoutProps,
  getFormControlErrorAriaProps,
  useFormControlIds,
} from './utils.js'

export const FormControlSelect = (props: FormControlSelectProps) => {
  const { layoutProps, inputProps } = extractLayoutProps(props)
  const { label } = props
  const ids = useFormControlIds()

  return (
    <FormControlLayout {...layoutProps} ids={ids}>
      <Select
        aria-labelledby={label ? ids.labelId : undefined}
        {...inputProps}
        {...getFormControlErrorAriaProps({ ...props, errorId: ids.errorId })}
      />
    </FormControlLayout>
  )
}
